export default "__VITE_ASSET__CwcB_Jwf__"